// Internal matcher logic
function match(value, matcher, testValue) {
  switch (matcher) {
    case 'is':
    case '===':
    case '==': return value === testValue;
    case 'not':
    case '!==':
    case '!=': return value !== testValue;
    case 'includes': return Array.isArray(value) && value.includes(testValue);
    case 'has': return typeof value === 'object' && value !== null && Object.values(value).includes(testValue);
    case 'in': return typeof value === 'object' && value !== null && testValue in value;
    case 'gt':
    case '>': return value > testValue;
    case 'lt':
    case '<': return value < testValue;
    case 'gte':
    case '>=': return value >= testValue;
    case 'lte':
    case '<=': return value <= testValue;
    default: throw new Error(`Unknown matcher: ${matcher}`);
  }
}

export function seek(obj, targetKey, matcher, testValue, currentPath = [], findAll = false) {
  const results = [];

  if (obj === null || typeof obj !== 'object') return results;

  for (const [key, value] of Object.entries(obj)) {
    // ✅ Check the key directly
    if (key === targetKey && match(value, matcher, testValue)) {
      results.push([...currentPath, key]);
      if (!findAll) return results;
    }

    // ✅ Recurse if object/array
    if (typeof value === 'object' && value !== null) {
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          const item = value[i];
          if (item && typeof item === 'object') {
            const nested = seek(item, targetKey, matcher, testValue, [...currentPath, key, i], findAll);
            results.push(...nested);
            if (!findAll && results.length > 0) return results;
          }
        }
      } else {
        const nested = seek(value, targetKey, matcher, testValue, [...currentPath, key], findAll);
        results.push(...nested);
        if (!findAll && results.length > 0) return results;
      }
    }
  }

  return results;
}

// Helper functions for common search patterns
export function findFirstNode(obj, key, matcher = 'is', value) {
  return seek(obj, key, matcher, value, [], false)?.[0];
}

export function findAllNodes(obj, key, matcher = 'is', value) {
  return seek(obj, key, matcher, value, [], true);
}